import { Icon, loadingOutlined } from '@surveycake/rc';
import { cx } from 'emotion';
import React, { ButtonHTMLAttributes, forwardRef } from 'react';
import { useStyles } from './styles';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  color?: 'primary';
  size?: 'medium' | 'large';
  loading?: boolean;
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      children,
      className,
      color,
      size = 'medium',
      disabled = false,
      loading = false,
      ...props
    },
    ref
  ) => {
    const styles = useStyles([color, size]);

    return (
      <button
        ref={ref}
        className={className ? cx(styles.button, className) : styles.button}
        disabled={disabled || loading}
        {...props}
      >
        {loading && <Icon icon={loadingOutlined} spin />}
        {React.Children.map(children, child => {
          if (typeof child === 'string') {
            return <span>{child}</span>;
          }

          return child;
        })}
      </button>
    );
  }
);

export default Button;
